import { push, replace } from 'connected-react-router';
import { takeLatest, put, select, call } from 'redux-saga/effects';

import * as actions from '../actions';
import { WIZARD_NAVIGATE } from '../constants/actionTypes';
import { NAV_FWD, NAV_BCK, APP_ELIGIBILITY_ERROR_HEAP } from '../constants/heapEvents';
import sectionLabels from '../constants/sectionLabels';
import { track } from '../lib/heapHelpers';
import * as decisionSelectors from '../lib/wizard/selectors';
import {
  wizardNextStepSelector,
  wizardPathsSelector,
  buildServerSelector,
  eligibilitySelector,
  eligibilityTimeStampFromServerSelector,
} from '../reducers/selectors';

import applicationCreateWorker from './applicationCreate';
import { persistAllWorker } from './persistAll';
import { progressSendWorker } from './progressSend';

function* wizardNavWatcher() {
  yield takeLatest(WIZARD_NAVIGATE, wizardNavWorker);
}

function eventProperties(url, pathObject, applicationId) {
  const { sec } = pathObject;
  return {
    'Application Path': url,
    'Application Section Number': sec,
    'Application Section Name': sectionLabels[sec] ? sectionLabels[sec].label : sectionLabels[sec],
    'Application Page Name': pathObject.name,
    'Application GUID': applicationId,
  };
}
function* wizardNavWorker(action) {
  const { payload } = action;
  const currentUrl = yield select(wizardNextStepSelector);
  const paths = yield select(wizardPathsSelector);
  const buildServer = yield select(buildServerSelector);
  const { id } = buildServer || { id: undefined };
  const index = paths.map(p => p.url).indexOf(currentUrl);
  const pathObject = paths[index];
  const { type: pathObjectType, selector, stateItemsToReset } = pathObject;
  const eligibilityTimeStampFromServer = yield select(eligibilityTimeStampFromServerSelector);
  const eligibility = yield select(eligibilitySelector);

  try {
    if (eligibilityTimeStampFromServer && !eligibility) {
      yield call(track, APP_ELIGIBILITY_ERROR_HEAP, eventProperties(currentUrl, pathObject, id));
    }
    const { dir: direction, resetState } = payload;

    if (direction === 'fwd') {
      if (stateItemsToReset && resetState === true) {
        yield put(actions.resetStateObjects(stateItemsToReset));
      }
      if (pathObjectType) {
        if (pathObjectType === 'create') {
          yield put(actions.setLoadingState(true));
          yield call(applicationCreateWorker, action);
          yield call(progressSendWorker, action);
          yield put(actions.setLoadingState(false));
        } else if (pathObjectType === 'save') {
          yield call(persistAllWorker, action);
        } else if (pathObjectType === 'fetchCapOnLoan') {
          yield put(actions.fetchCapOnLoan());
        }
      }

      if (selector) {
        if (!decisionSelectors[selector]) {
          throw new Error(`"selector" parameter is invalid. Selector ${selector} not found.`);
        }

        const selectorValue = yield select(decisionSelectors[selector]);
        if (selectorValue !== undefined) {
          yield put(actions.updateWizardForward({ currentUrl, flag: selectorValue }));
        }
      }

      yield call(track, NAV_FWD, eventProperties(currentUrl, pathObject, id));
      yield put(actions.navigateWizardForward());
    }

    if (direction === 'back') {
      if (pathObjectType === 'newSection') {
        yield put(actions.navigateWizardBack());
        yield put(actions.updateWizardBack(currentUrl));
      }
      yield call(track, NAV_BCK, eventProperties(currentUrl, pathObject, id));
      yield put(actions.navigateWizardBack());
      yield put(actions.updateWizardBack(currentUrl));
    }
    const newUrl = yield select(wizardNextStepSelector);

    if (direction === 'fwd') {
      yield put(push(newUrl));
    } else {
      yield put(replace(newUrl));
    }
  } catch (error) {
    yield put(actions.notifyError({ ...error, action }));
  }
}

export { wizardNavWorker };
export default wizardNavWatcher;
